/**
 * Tenant-scoped Redux reset hub for org switches / sign-out / some 401 paths.
 */
import { batch } from 'react-redux';
import type { AppThunk } from '../../../store';
import { removeItem } from '../../../utils/storage';
import { resetAlarmSlice } from '../../Alarm/AlarmSlice';
import { resetCompleteChecklistStore } from '../../Checklists/checklistsSlice';
import { resetAll as resetCreateMessage } from '../../CreateMessage/createMessageSlice';
import { resetDocumentSlice } from '../../Documents/documentsSlice';
import { tenantScopeReset } from './tenantScopeReset';

/** Clears tenant-scoped Redux/cache state before tenant hand-off. */
export const resetTenantScopedSlices = (): AppThunk => dispatch => {
  batch(() => {
    dispatch(tenantScopeReset());
    // Pre-existing slice-specific reset actions (wire these via extraReducers
    // + `tenantScopeReset` if you'd like to drop them from this list).
    dispatch(resetDocumentSlice());
    dispatch(resetAlarmSlice());
    dispatch(resetCompleteChecklistStore());
    dispatch(resetCreateMessage());
  });

  removeItem('panicButtonData');
  removeItem('csrf');
  removeItem('APP_FILTERS');
};
